import request from '@/config/axios'

export interface PlatformOverviewVO {
  hotelCount: number
  activeHotelCount: number
  configuredHotelCount: number
  totalOrderCount: number
  todayOrderCount: number
  todayRevenue: number
  pendingReviewCount: number
  hiddenReviewCount: number
  totalReviewCount: number
  unhandledAlertCount: number
  totalRooms: number
  occupiedRooms: number
  occupancyRate: number
}

// 平台概况聚合指标（跨全部酒店）
export const getPlatformOverview = () => {
  return request.get<PlatformOverviewVO>({ url: '/hotel/platform/dashboard/overview' })
}
